module.exports = __webpack_public_path__ + "img/play-blue.abf380e9.png";